import { render } from "./ContactSection.vue?vue&type=template&id=2dcf39c9&scoped=true"
import script from "./ContactSection.vue?vue&type=script&lang=js"
export * from "./ContactSection.vue?vue&type=script&lang=js"

import "./ContactSection.vue?vue&type=style&index=0&id=2dcf39c9&scoped=true&lang=scss"

import exportComponent from "/builds/blat/bcard-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dcf39c9"]])

export default __exports__